import { render, staticRenderFns } from "./taskClaim.vue?vue&type=template&id=05ad894e&scoped=true"
import script from "./taskClaim.vue?vue&type=script&lang=js"
export * from "./taskClaim.vue?vue&type=script&lang=js"
import style0 from "./taskClaim.vue?vue&type=style&index=0&id=05ad894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad894e",
  null
  
)

export default component.exports